document.addEventListener("DOMContentLoaded", function () {
  // store modals
  const modals = {};

  // create modals
  Array.from(document.getElementsByClassName("ac-modal")).forEach((modalElement) => {
    // modal
    const modal = modalElement

    // store in dictionary
    const modalId = modalElement.getAttribute("id");
    modals[modalId] = modal;
  });

  // open modal
  Array.from(document.querySelectorAll(".ac-modal-trigger[data-ajax-url], .ac-modal-trigger[data-modal-target]")).forEach((trigger) => {
    const targetModalId = trigger.getAttribute("data-modal-target");
    const modal = modals[targetModalId];
    if (modal) {
      // open corresponding modal
      trigger.addEventListener("click", () => {
        onModalTriggerClick(trigger, modal);
      });
      onModalClose(trigger, modal);
    }
  });
});

async function onModalTriggerClick(trigger, modal) {
  if (!trigger || !modal) return;

  if (trigger.dataset.ajaxLoaded) return;

  const {
    ajaxUrl,
    ajaxIframe,
    customCompare,
  } = trigger.dataset;

  if (!ajaxUrl) return

  toggleLoadingState(modal, true);
  const html = await fetch(ajaxUrl)
    .then((response) => {
      return response.text();
    }).then((html) => {
      return html
    }).catch((error) => {
      console.error(error)
    });

  if (!html) return

  if (ajaxIframe) {
    const iframe = document.createElement("iframe");
    iframe.style.width = '100%';
    iframe.style.height = '100%';
    iframe.style.border = 'none';

    modal.appendChild(iframe);

    // Set the iframe onload event before setting srcdoc
    openLinkInNewTab(iframe);

    iframe.srcdoc = html; // Load the dynamic content into the iframe
  } else {
    const template = SDG?.Data?.template || '';

    if (template?.includes('collection.plp') && customCompare && modal) {
      // Wait for the modal to be fully loaded
      setTimeout(() => {
        var $scripts = modal.querySelectorAll('script') || [];

        if ($scripts?.length > 0) {
          $scripts.forEach(script => {
            if (script.textContent.includes('channelCompare')) {
                let scriptContent = script.textContent.replace(/const reorderDOM/g, 'var reorderDOM');
                const $compareHeader = modal.querySelectorAll('#interactive-compare-header');
                const newScript = document.createElement('script');
                newScript.textContent = scriptContent;
                modal.appendChild(newScript);

              if ($compareHeader && typeof channelCompare !== 'undefined' && channelCompare?.init) {
                channelCompare.init();
              }
            }
          });
        }
      }, 500);
    }

    modal.innerHTML = html;
  }

  trigger.dataset.ajaxLoaded = true;
  toggleLoadingState(modal, false);
}

function openLinkInNewTab(iframe) {
  iframe.onload = function () {
    var iframeDocument = iframe.contentWindow.document;
    var links = iframeDocument.querySelectorAll('a');
    for (var i = 0; i < links.length; i++) {
      // Check if the link already has a target attribute
      if (!links[i].getAttribute('target')) {
        // If not, add target="_blank"
        links[i].setAttribute('target', '_parent');
      }

      links[i].addEventListener('click', function (event) {
        event.preventDefault();
        var href = this.getAttribute('href');

        if (href) {
          window.open(href, '_parent'); // Open the link in a new tab
        }
      });
    }

    // adobe tracking
    setTimeout(() => {
      window.adobeTrackMarketingPageIframeCtaClick(iframe);
      window.adobeTrackMarketingPageIframeScroll(iframe);
    }, 10);
  };
}

/**
 * toggle loading state for modal
 * @param {Node} $modal
 * @param {Boolean} isLoading
 */
function toggleLoadingState($modal, isLoading) {
  const $modalSpinner = $modal.querySelector('.ac-progress-indicator');
  const $modalSpinnerParent = $modalSpinner?.parentNode;
  if (isLoading) {
    $modal.classList.add('is-loading');
  } else {
    $modal.classList.remove('is-loading');
    if ($modalSpinnerParent) $modal.removeChild($modalSpinnerParent);
  }
}

/**
 * on modal close
 * @param  {Node} $trigger trigger element
 * @param  {Node} $modal modal element
 */
function onModalClose($trigger, $modal) {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        window.pauseAllMedia();
        if(mutation.attributeName == 'class'){
            const isOpen = mutation.target.classList.contains('modal-open');
            // clear modal content if modal is closed
            if (!isOpen) {
              const { ajaxUrl } = $trigger.dataset;
              if (ajaxUrl) {
                setTimeout(() => {
                  const $modalContent = mutation.target.querySelector('.ac-modal');
                  $modalContent.innerHTML = `
                    <div class="seedkit-component-standalone">
                      <div class="ac-progress-indicator">
                        <div data-progress-indicator="" class="progress-indicator progress-indicator-indeterminate progress-indicator-immediate progress-indicator-curtain progress-indicator-visible">
                          <svg class="progress-indicator-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56 56" aria-hidden="true">
                              <g class="progress-indicator-spokes">
                                  <path class="progress-indicator-spoke" d="M28,8.5A2.5,2.5,0,0,1,30.5,11v7a2.5,2.5,0,0,1-5,0V11A2.5,2.5,0,0,1,28,8.5Z"></path>
                                  <path class="progress-indicator-spoke" d="M41.79,14.21a2.52,2.52,0,0,1,0,3.54L36.84,22.7a2.5,2.5,0,0,1-3.54-3.54l5-4.95A2.52,2.52,0,0,1,41.79,14.21Z"></path>
                                  <path class="progress-indicator-spoke" d="M47.5,28A2.5,2.5,0,0,1,45,30.5H38a2.5,2.5,0,0,1,0-5h7A2.5,2.5,0,0,1,47.5,28Z"></path>
                                  <path class="progress-indicator-spoke" d="M41.79,41.79a2.52,2.52,0,0,1-3.54,0l-5-4.95a2.5,2.5,0,0,1,3.54-3.54l4.95,5A2.52,2.52,0,0,1,41.79,41.79Z"></path>
                                  <path class="progress-indicator-spoke" d="M28,47.5A2.5,2.5,0,0,1,25.5,45V38a2.5,2.5,0,0,1,5,0v7A2.5,2.5,0,0,1,28,47.5Z"></path>
                                  <path class="progress-indicator-spoke" d="M14.21,41.79a2.52,2.52,0,0,1,0-3.54l4.95-5a2.5,2.5,0,0,1,3.54,3.54l-4.95,4.95A2.52,2.52,0,0,1,14.21,41.79Z"></path>
                                  <path class="progress-indicator-spoke" d="M8.5,28A2.5,2.5,0,0,1,11,25.5h7a2.5,2.5,0,0,1,0,5H11A2.5,2.5,0,0,1,8.5,28Z"></path>
                                  <path class="progress-indicator-spoke" d="M14.21,14.21a2.52,2.52,0,0,1,3.54,0l4.95,4.95a2.5,2.5,0,0,1-3.54,3.54l-4.95-4.95A2.52,2.52,0,0,1,14.21,14.21Z"></path>
                              </g>
                          </svg>
                        </div>
                      </div>
                    </div>
                  `;
                  $trigger.removeAttribute('data-ajax-loaded');
                }, 500);
              } else {
                // stop video if modal is closed
                const $video = mutation.target.querySelector('video');
                if ($video) {
                  $video.pause();
                  $video.currentTime = 0;
                }
              }
            }
        }
    });
  });
  const $modalRoot = $modal.closest('.modal');
  if (!$modalRoot) return;
  observer.observe($modalRoot, {attributes: true});
}
